/**
 * Извлекает путь из state, если он там сохранен
 * Формат state: "randomState|/path"
 */
export const getPathFromState = (state: string): string | null => {
  if (!state) return null;

  try {
    const decodedState = decodeURIComponent(state);
    const parts = decodedState.split('|');
    return parts.length > 1 ? parts[1] : null;
  } catch {
    return null;
  }
};

/**
 * Извлекает путь из state, закодированного в Base64
 * Формат state: Base64 от "randomState|/path"
 * Пример: "NzIzNDY2NjgwfC8=" -> "/"
 */
export const getPathFromStateBase64 = (state: string): string | null => {
  if (!state) return null;

  try {
    const decoded = atob(state);
    const parts = decoded.split('|');
    return parts.length > 1 ? parts[1] : null;
  } catch {
    return null;
  }
};
